export default __webpack_public_path__ + "static/media/Angle.f5dea62c.jpeg";